import { Button } from "@chakra-ui/react";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import type { NavButtonProps } from "./types";

export const NavButton = (props: NavButtonProps) => {
  const { href, title, gaEvent, uaEvent, dataTestId, variant = "secondary" } = props;

  const handletrackEvents = () => {
    trackUAEvent(uaEvent);
    trackCustomEvent(gaEvent);
  };
  return (
    <Button
      variant={variant}
      as="a"
      href={href}
      title={title}
      px={{ lg: 3, xl: 6 }}
      width={{ base: "full", lg: "initial" }}
      onClick={handletrackEvents}
      data-testid={dataTestId}
      lineHeight="short"
      textAlign={{ base: "center", lg: "unset" }}
    >
      {title}
    </Button>
  );
};
